//
//  Supernova SDK
//
//  Created by Jiri Trecak.
//
// --- --- --- --- --- --- --- --- --- --- --- --- --- --- --- --- --- --- --- --- --- --- --- --- --- --- ---
// MARK: - Imports
import { Resource, ResourceType } from "./SDKResource";
// --- --- --- --- --- --- --- --- --- --- --- --- --- --- --- --- --- --- --- --- --- --- --- --- --- --- ---
// MARK: -  Object Definition
export class ResourceFont extends Resource {
    // --- --- --- --- --- --- --- --- --- --- --- --- --- --- --- --- --- --- --- --- --- --- --- --- --- ---
    // MARK: - Constructor
    constructor(model) {
        var _a, _b, _c, _d, _e, _f, _g, _h;
        super(model);
        // --- --- --- --- --- --- --- --- --- --- --- --- --- --- --- --- --- --- --- --- --- --- --- --- --- ---
        // MARK: - Public properties
        this.type = ResourceType.font;
        this.fontProperties = null;
        this.type = ResourceType.asset;
        const fontProperties = (_a = model.fontProperties) === null || _a === void 0 ? void 0 : _a.at(0);
        if (fontProperties) {
            this.fontProperties = {
                family: (_b = fontProperties.family) !== null && _b !== void 0 ? _b : null,
                subfamily: (_c = fontProperties.subfamily) !== null && _c !== void 0 ? _c : null,
                weight: (_d = fontProperties.weight) !== null && _d !== void 0 ? _d : null,
                isItalic: (_e = fontProperties.isItalic) !== null && _e !== void 0 ? _e : null,
                isOutlined: (_f = fontProperties.isOutlined) !== null && _f !== void 0 ? _f : null,
                isStrikeout: (_g = fontProperties.isStrikeout) !== null && _g !== void 0 ? _g : null,
                isUnderscore: (_h = fontProperties.isUnderscore) !== null && _h !== void 0 ? _h : null,
            };
        }
    }
}
